// extracted by mini-css-extract-plugin
export default {"item__category":"CategoryCards_item__category__gcOAp","name__category":"CategoryCards_name__category__hcS8y","text__category":"CategoryCards_text__category__Rwra6"};